module.exports = __webpack_public_path__ + "assets/img/wen_tu01.be33b8cb.jpg";